const getResult = 'getResult'
const getPlayList = 'getPlayList'
import { $getResult, $getPlayList } from '../api/http'
import {
  SEASON_TYPE_MAP,
  INDEX_TYPE_MAP,
  TYPE_MAP,
  PAGE_SIZE,
} from '../utils/constants'
import toast from '@bilibili/vanilla-toast'
export default {
  async [getResult]({ state }, { page = 1, loadMore = false }) {
    if (state.resultLoading) {
      toast.info('查询中，请稍后筛选...')
    }
    state.resultLoading = true
    try {
      const result: any = await $getResult({
        page,
        loadMore, //是否加载更多
        pagesize: PAGE_SIZE,
        season_type: SEASON_TYPE_MAP.DOCUMENTARY,
        index_type: INDEX_TYPE_MAP.DOCUMENTARY,
        type: TYPE_MAP.WEB,
        order: state.order,
        sort: state.sort,
        style_id: state.styleId,
        producer_id: state.producerId,
      })
      const { list = [] } = result || {}
      if (loadMore && state.result?.list.length) {
        state.result.list.push(...list)
      } else {
        state.result.list = list
      }
      state.result = {
        ...result,
        list: state.result.list,
      }
      state.resultLoading = false
    } catch (err) {
      toast.info('筛选失败，请重试')
      state.resultLoading = false
    }
  },
  async [getPlayList]({ state }) {
    try {
      const res: any = await $getPlayList({
        id: state.id,
      })
      const { code, result: data } = res
      if (code === 0) {
        state.sheetList = data
      } else {
        toast.info('请稍后再试')
      }
    } catch (err) {
      toast.info('片单获取失败，请重试')
    }
  },
}
